module.exports = __webpack_public_path__ + "static/img/logo54.1edffa5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo54.png
// module id = nx0P
// module chunks = 1